import {React, observable, Sentry, Fragment} from '@api'
import {onSiteError} from '@stores'
import * as css from './ErrorBoundary.css'
import { Card, CardContent, Typography } from '@material-ui/core'
import {observer} from 'mobx-react'

@observer
export class ErrorBoundary extends React.Component<{ errorContent?: (error: Error) => React.ReactNode}, {}> {
  @observable error: Error
  info

  componentDidCatch(error, info) {
    this.error = error
    this.info = info
    Sentry.captureException(error)
    //console.error(error, info)
  }

  render() {
    const {error, info, props: {children, errorContent}} = this

    return <Fragment>
      {error ? (errorContent ? errorContent(error) : <Card className={css.root}>
               <CardContent>
                 <Typography
                   onClick={() => {
                     console.error(error)
                     console.log(info)
                   }}
                   className={css.title}>Component Error</Typography>

                 <div className={css.stack}>
                   {error.stack}
                   {/*{info.componentStack.trim()}*/}
                 </div>
               </CardContent>
             </Card>)
             : children}
    </Fragment>
  }
}

@observer
export class ErrorBoundaryToast extends React.Component<{}, {}> {
  @observable error: Error
  info

  componentDidCatch(error, info) {
    this.error = error
    this.info = info
    Sentry.captureException(error)
    onSiteError(error)
    //console.error(error, info)
  }

  render() {
    const {error, info, props: {children}} = this

    return children
  }
}



// WEBPACK FOOTER //
// ./src/modules/common/components/ErrorBoundary.tsx